import React, { FC } from 'react';
import { useTheme } from '@material-ui/core';
import { Icons } from '../../../../shared/components';
import {
  AddIcon,
  AddIconWrapper,
  SectionIcon,
  StyledButton,
  Title,
  StyledParagraph,
} from '../../AddSectionButton';

type Props = {
  icon: Icons;
  title: string;
  description: string;
  onClick: () => void;
};

const AddSectionButton: FC<Props> = ({ icon, title, description, onClick }) => {
  const theme = useTheme();

  return (
    <StyledButton onClick={onClick}>
      <SectionIcon icon={icon} />
      <Title variant="h3">{title}</Title>
      <StyledParagraph>{description}</StyledParagraph>
      <AddIconWrapper>
        <AddIcon color={theme.palette.common.white} icon={Icons.ADD} />
      </AddIconWrapper>
    </StyledButton>
  );
};

export default AddSectionButton;
